// test276
(276 && 0);
